<!-- 좌석 선택 페이지 -->
<template>
<div id="payment_seat">
    <div class="pay_process">
        <!-- <div class="loading" v-show="loading">
            <img src="../../assets/image/loading.gif">
        </div> -->
        <div class="pay_process_wrap">
            <div class="progress-bar-wrap">
                <div class="progress-bar">
                    <div class="bar">
                        <div class="_fill"></div>
                    </div>
                    <div class="point" v-for="(item, index) in left_menu_list" :key="'left_menu'+index" :class="item['active_class']">
                        <div class="bullet">
                            <img :src="item.img_src">
                        </div>
                        <label class="label">{{item.menu_name}}</label>

                    </div>
                </div>
            </div>
            <!-- 오른쪽화면 -->
            <div class="process_content">
                <div class="pay_content_wrap">

                    <!-- 좌석상품구매화면(타입선택) - 고정석 -->
                    <div class="pay_content_01 pay_content" v-if="step==1">
                        <div class="paytit mylist">
                            <div class="btn_mylist">
                                <div @click="use_my_coupon_alarm">내 상품 &amp; 내 쿠폰</div>
                            </div>
                        </div>
                        <p v-if ="use_extention_flag == true" style = "font-size: 12px; color: #f00; padding: 3px; word-break: keep-all;">
                            ※ 연장 결제를 하더라도 기존 상품의 남은 시간은 합산되지 않습니다.
                        </p>
                        <ul class="hidden-scroll">
                            <template v-for=" (item , index) in seat_product">

                                <li :key="'pay_content01'+index" v-if="item.show_class == 'y'" :class="item['active_class']" @click="set_seat_goods_group_id(item, index)">

                                    <div>{{item.goods_group_name}}</div>
                                </li>
                            </template>
                        </ul> 
                    </div>

                    <!-- 시간선택 -->
                    <div class="pay_content_02 pay_content" v-if="step==2">
                        <div class="paytit">
                        </div>
                        <ul>
                            <template v-for=" (item , index) in seat_goods_time_list">
                                <li v-if="(item.continue_goods_yn == 0 || item.continue_goods_yn == 2) && use_extention_flag == false" :key="'pay_content02'+index" :class="item['active_class']" @click="set_seat_time_product(item, index)">

                                    <template v-if="item.day_count !== null && item.hours === null && item.event_goods === false">
                                        {{item.day_count}}일
                                    </template>
                                    <template v-if="item.day_count !== null && item.hours === null && item.event_goods === true">
                                        <template v-if="item.event_goods_name !== null && item.event_goods_name !== ''">
                                            <div style="color:#ffae00;" :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.event_goods_name}}(행사)
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div style="color:#ffae00;" :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.day_count}}일(행사)
                                            </div>
                                        </template>                                        
                                    </template>

                                    <!-- 시간충전권 -->
                                    <template v-if="item.hours !== null && item.day_count === null && item.event_goods === false">
                                        <template v-if="item.goods_name !== null && item.goods_name !== ''">
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.goods_name}}
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.hours/60}}시간
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                    </template>

                                    <!-- 시간충전권 행사 -->
                                    <template v-if="item.hours !== null && item.day_count === null && item.event_goods === true">
                                        <template v-if="item.event_goods_name !== null && item.event_goods_name !== ''"> 
                                            <div style="color:#ffae00;" :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.event_goods_name}}(행사)
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div style="color:#ffae00;" :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.hours/60}}시간(행사)
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                    </template>

                                    <template v-if="item.hours === null && item.day_count === null && item.event_goods === false">
                                        {{item.start_time}}~{{item.end_time}}
                                    </template>
                                    <template v-if="item.hours === null && item.day_count === null && item.event_goods === true">
                                        {{item.start_time}}~{{item.end_time}}(행사)
                                    </template>
                                </li>
                            </template>

                            <template v-for=" (item , index) in seat_goods_time_list">
                                <li v-if="(use_extention_flag == true && item.continue_goods_yn != 2)" :key="'pay_content02'+index" :class="item['active_class']" @click="set_seat_time_product(item, index)">

                                    <template v-if="item.day_count !== null && item.hours === null && item.event_goods === false && item.continue_goods_yn === 0">
                                        {{item.day_count}}일
                                    </template>
                                    <template v-if="item.day_count !== null && item.hours === null && item.event_goods === true">
                                        {{item.day_count}}일(행사)
                                    </template>
                                    <template v-if="item.day_count !== null && item.hours === null && item.event_goods === false && item.continue_goods_yn === 1">
                                        {{item.day_count}}일(연장)
                                    </template>

                                    <template v-if="item.hours !== null && item.day_count === null && item.event_goods === false && item.continue_goods_yn === 0">
                                        <template v-if="item.goods_name !== null && item.goods_name !== ''">
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.goods_name}}
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.hours/60}}시간
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-if="item.hours !== null && item.day_count === null && item.event_goods === true">
                                        <template v-if="item.event_goods_name !== null && item.event_goods_name !== ''">
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.event_goods_name}}(행사)
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.hours/60}}시간(행사)
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-if="item.hours !== null && item.day_count === null && item.event_goods === false && item.continue_goods_yn === 1">
                                        <template v-if="item.goods_name !== null && item.goods_name !== ''"> 
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.goods_name}}(연장)
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div :class="[item.end_day_count !== null ? 'hours_value' : {}]">{{item.hours/60}}시간(연장)
                                                <div v-if="item.end_day_count !== null" class='end_day'>( 만료기간 : {{item.end_day_count}}일 )</div>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-if="item.hours === null && item.day_count === null && item.event_goods === false && item.continue_goods_yn === 0">
                                        {{item.start_time}}~{{item.end_time}}
                                    </template>
                                    <template v-if="item.hours === null && item.day_count === null && item.event_goods === true">
                                        {{item.start_time}}~{{item.end_time}}(행사)
                                    </template>
                                    <template v-if="item.hours === null && item.day_count === null && item.event_goods === true && item.continue_goods_yn === 1">
                                        {{item.start_time}}~{{item.end_time}}(연장)
                                    </template>
                                </li>
                            </template>

                        </ul>
                        <!-- <template v-if="use_time_settings_yn == 1">
                            <div class="money_select_box_wrap">
                                <div class="select_usingtime">
                                    <b>금일사용시간 :</b>
                                    <select v-model="choice_use_time">
                                        <option v-for="(item ,index) in choice_use_time_list" :value=(index+1)*60 :key="item">{{item}}</option>
                                    </select>
                                </div>
                            </div>
                        </template> -->

                    </div>

                    <!-- 마일리지 -->
                    <div class="pay_content_05 pay_content" v-if="step==3 && mileage_use_yn == 1">
                        <div class="paytit">
                        </div>
                        <ul class="hidden-scroll">
                            <template v-if="mileage_chk === false">
                                <li @click="set_mileage(false)" class="pay-content-on">
                                    <div>마일리지미사용</div>

                                </li>
                                <li @click="set_mileage(true)">
                                    <div>마일리지사용</div>

                                </li>
                            </template>
                            <template v-else>
                                <li @click="set_mileage(false)">
                                    <div>마일리지미사용</div>

                                </li>
                                <li @click="set_mileage(true)" class="pay-content-on">
                                    <div>마일리지사용</div>

                                </li>
                            </template>
                        </ul>
                        <template v-if="mileage_chk === true">
                            <div class="mg_box_wrap hidden-scroll">
                                <div>
                                    <span>적립금액 </span>
                                    <mileage @milage="milage_payment" />
                                </div>

                                <div>
                                    <span>적용금액 </span>
                                    <span class="m-mileag">{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                </div>
                                <ul>
                                    <li @click="set_mileage_button(use_min_unit)">+ {{use_min_unit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                    <li @click="set_mileage_button(use_min_unit*2)">+ {{(use_min_unit*2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                    <li @click="set_mileage_button(use_min_unit*10)">+ {{(use_min_unit*10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                    <li @click="set_mileage_button('all')">전체적용</li>
                                    <li @click="set_mileage_button('cancel')">전체취소</li>
                                </ul>

                                <p>※ 최소사용단위 : {{use_min_unit}}원 ※ 최소사용금액 : {{use_min_amount}}원</p>
                            </div>
                        </template>

                    </div><!-- 마일리지 -->

                    <!-- 할인쿠폰 -->
                    <div class="pay_content_06 pay_content" v-if="step==4 && sale_use_yn == 1">
                        <div class="paytit">
                            <div class="paytit-text"></div>
                        </div>
                        <ul class="hidden-scroll">
                            <template v-if="discount_coupon === true">
                                <li @click="set_discount_coupon(false)">
                                    <div>할인쿠폰미사용</div>

                                </li>
                                <li @click="set_discount_coupon(true)" class="pay-content-on">
                                    <div>할인쿠폰사용</div>

                                </li>
                            </template>
                            <template v-else>
                                <li @click="set_discount_coupon(false)" class="pay-content-on">
                                    <div>할인쿠폰미사용</div>

                                </li>
                                <li @click="set_discount_coupon(true)">
                                    <div>할인쿠폰사용</div>

                                </li>
                            </template>
                        </ul>
                        <template v-if="discount_coupon === true">
                            <div class="cp_box_wrap">
                                <div class="cp_box">
                                    <span>쿠폰코드 :</span>
                                    <span>{{discount_coupon_code | coupon_filter}}</span>
                                </div>
                                <button @click="coupon_check()">적용</button>
                            </div>

                            <div class="cp_num_pad">
                                <div class="pad_btn">
                                    <span @click="coupoun_input('1')">1</span>
                                    <span @click="coupoun_input('2')">2</span>
                                    <span @click="coupoun_input('3')">3</span>
                                    <span @click="coupoun_input('4')">4</span>
                                    <span @click="coupoun_input('5')">5</span>
                                    <span @click="coupoun_input('6')">6</span>
                                </div>
                                <div class="pad_btn">
                                    <span @click="coupoun_input('7')">7</span>
                                    <span @click="coupoun_input('8')">8</span>
                                    <span @click="coupoun_input('9')">9</span>
                                    <span @click="coupoun_input('0')">0</span>
                                    <span @click="coupoun_input('del')"><img src='../../assets/image/delete_gy.png'></span>
                                </div>

                            </div>
                        </template>

                    </div>
                    <!-- 결제 전 환불안내 -->
                    <div class="pay_content_06 pay_content" v-if="step==5" style="overflow: hidden">
                      <template v-if="refund !='' && refund != undefined">
                        <p>환불규정</p>
                        <br>
                        <textarea readonly disabled style="width: 100%;height: 100%;border: none;">{{ refund }}</textarea>
                      </template>
                    </div>

                    <!-- 결제 완료 -->
                    <div class="pay_content_09 pay_content" v-if="step==6">
                        <div class="finish_payment_wrap">
                            <div class="finish_head" v-if="last_price_card != 0">
                                <ul>
                                    <li>
                                        <span class="pay_hd">결제금액</span>
                                        <span class="pay_ft">{{last_price_card}} 원</span>
                                    </li>
                                </ul>
                            </div>

                            <div class="finish_body">
                                <p v-if="last_price_card != 0">결제가 완료되었습니다.</p>
                                <img src="../../assets/image/barcode_img.jpg">
                                <p>입력하신 휴대폰 번호로 <br><span>결제 정보</span>가 담긴 문자가 전송됩니다.
                                <!-- 250514 이용안내 팝업 추가 -->
                                <div v-if="usage_guide_useyn=='y'" class="guide_btn_wrap">
                                    <div class="guide_btn" @click="open_guide()">이용안내</div>
                                </div>
                                
                                </p>
                            </div>

                            <div class="finish_footer pay_content_btn">
                                <div class="ok_btn" @click="step_finish(-1)">확인</div>
                            </div>
                        </div>
                    </div><!-- 결제 완료 -->

                </div> <!-- 오른쪽메뉴2 -->

                <div class="pay_info" v-if="step <= 5">
                    <div class="pay_info_wrap" >
                        <div class="pay_wrap">
                            <ul>
                                <li>
                                    <div class="pay_hd">좌석타입</div>
                                    <div class="pay_ft">{{ seat_type_name }}</div>
                                </li>
                                <li>
                                    <div class="pay_hd">상품종류</div>
                                    <div class="pay_ft">{{seat_goods_group_name}}</div>
                                </li>
                                <li>
                                    <div class="pay_hd">이용시간</div>
                                    <div class="pay_ft">{{my_select_goods_name}}</div>
                                </li>
                                <li>
                                    <div class="pay_hd">만료일자</div>
                                    <div class="pay_ft">{{end_date}}</div>
                                </li>
                                <li>
                                    <div class="pay_hd">상품구분</div>
                                    <div class="pay_ft">{{division}}</div>
                                </li>
                                <li v-if="mileage_use_yn == 1">
                                    <div class="pay_hd">마일리지</div>
                                    <div class="pay_ft price">{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}{{mileage_text}}</div>
                                </li>
                                <li v-if=" sale_use_yn == 1">
                                    <div class="pay_hd">할인금액</div>
                                    <div class="pay_ft price">{{discounted_price_card}}{{discount_text}}</div>
                                </li>
                                <li>
                                    <div class="pay_hd">결제금액</div>
                                    <div class="pay_ft price">{{last_price_card}}{{price_text}}</div>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>
            <div class="pay_content_btn" v-if="step == 1">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>

                </div>
                <div class="pay_content_btn" v-if="step == 2">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
                </div>
                <div class="pay_content_btn" v-if="step==3 && mileage_use_yn == 1">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
                </div>
                <div class="pay_content_btn" v-if="step==4 && sale_use_yn == 1">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
                </div>
                <div class="pay_content_btn" v-if="step == 5">
                    <div class="prev_btn" @click="step_controll_back()">
                        이전
                    </div>
                    <div class="next_btn" @click="do_pay_check()">결제하기</div>
                </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../javascript/config';
import moment from 'vue-moment';
import vue from 'vue';
import mileage from "../components/mileage";
// 결제모듈
// import external from '@/assets/js/external.js';

vue.use(moment);
vue.component('mileage', mileage);
export default {
    data: function () {
        return {
            step: 1,
            before_step: 1,
            left_menu_list: [],
            now_date: '',
            end_date: null,
            end_date_for_server: null,
            expiration_date: null, // 유효기간
            user_id: '',
            user_Ph_number: '',
            userName: '',
            //결제관련
            product: '5', //defalt 5
            time: 'no',

            my_select_goods_name: '',

            //////// new logic
            seat_id: '',
            seat_name: '',
            seat_type_code: '',
            seat_type_name: '',
            seat_status_code: '',
            cash: true,
            //좌석상품
            seat_product: [],
            seat_goods_group_id: '',
            seat_goods_group_name: '',
            seat_goods_type_code: '',
            sub_product_name: '',
            use_time_settings_yn: '',

            //시간상품
            seat_goods_time_list: [],
            seat_goods_time_eventlist: [],
            seat_goods_item_name: '',
            card_amount: '',
            seat_goods_id: '',
            mileage_save_yn: '',
            seat_event_goods_id: null,
            end_day_count: null,
            division: '',
            card_installment: 0, // 0 = 일시불 2 = 2개월 13 = default
            cash_receipt: '0', // 0 == 개인(소득공제) 1 == 법인(지출증빙)
            card_div: '0',
            //마일리지
            mileage_use_yn: '', //해당 매장에서 마일리지 사용여부
            mileage_chk: false,
            mileage_id: null,
            my_save_mileage: 0,
            milage_all: false,
            use_mileage: '',

            //할인쿠폰
            sale_use_yn: '', // 해당 매장에서 할인쿠폰 사용여부
            discount_coupon: false,
            discount_coupon_code: '',
            sale_id: 0,
            sale_rate: 0,
            discounted_price_card: '',
            discount_flag: false,

            // 내 좌석 상품 , 쿠폰
            my_seat_product_list: [],
            my_seat_product_name: '',
            my_seat_product_time: '',
            my_seat_product_end_datetime: '',
            my_seat_product_left_time: '',
            my_seat_product_purchase_history_id: '',
            my_coupon_list: [],

            last_price_card: '',

            input_cash: '0',
            cash_wait_text: '결제가 완료될때까지 기다려주세요!',

            // 금일 상품 시간 사용계획
            choice_use_time_list: [],
            choice_use_time: 0, // 값이 1일경우 1시간,
            // 금일 상품 시간 사용계획 - 이미 구매한 상품용
            choice_use_time_left_list: [],
            choice_use_left_time: 0, // 값이 1일경우 1시간

            // 이용연장을 위한 사용하던 상품 데이터
            use_extention_seat_purchase_history_id: '',
            use_extention_use_end_datetime: '',
            use_extention_flag: false,
            use_extention_use_start_datetime: '',
            after_use_extention_use_end_datetime: '',
            day_count: '',
            use_hours_plan: 0,

            // 영수증 출력
            receipt_chk: 0,
            move_step: 0,

            // 마일리지 사용 최소 단위
            use_min_unit: 0,
            // 마일리지 사용 최소 금액
            use_min_amount: 0,

            // 상품 최대 사용 시간 설정
            use_time_settings_yn: 0,
            // 만료기간 설정 여부
            end_term_yn: 0,
            // 사용 최대 시간
            max_use_time: 0,
            // 해당 좌석의 상태를 LOCK 으로 걸어놓을지 여부를 판단하는 flag
            lock_condition: false,
            // 잔돈 방출 시 다음스텝으로 진행할 지 여부
            payment_return_kind: false,
            // 결제 진행 도중 취소버튼 안보이게
            btn_display_status: "inline-block",
            // 결제 정보 관련
            app_number: 0, // 승인번호
            payment_kind_name: '', // 현금 : 종류, 카드 : 카드사명
            card_number: '', // 카드번호(현금영수증번호)
            my_seat_list: [],

            special_goods_flag: false, // 시간충전권 , 기간권 , 1일시간권 이 아닌 주간권,야간권,주간기간권,야간기간권을 체크하기위한 flag
            atalk_end_date: '',
            mileage_text: '',
            discount_text: '',
            price_text: '',

            store_pay_yn: this.$store.getters['getStore_pay_info'],
            loading: false,
            // 좌석 락 타임 유효시간 관리
            lock_time: 480, // 락 유효시간
            lock_use_time: 460,  // 락 갱신시간
            lock_timer : null,  // 락 타이머
            skip_flag: false,  // 다음 스텝으로 못넘어가게 하는 플래그
            refund: '',  // 환불규정

            usage_guide_useyn: 'n', //이용안내 사용여부
            usage_guide_data: null, //이용안내 데이터
        }
    },
    filters: {
        coupon_filter(value) {
            var num = new Number(value);
            num = num.toFixed(0).replace(/\B(?=(\d{4})+(?!\d))/g, "-");
            return `${num}`
        }
    },
    props: [
        'hot_table',
    ],
    methods: {
        step_finish() {

            var router = this.$router;
            router.push('/');
        },
        choice_myproduct(item) {
            this.my_seat_product_name = item.goods_group_name;
            var array_length = item.left_time;
            if (this.my_seat_product_name == '기간권') {
                array_length = 10;
            }
            if (item.left_time > 10) {
                array_length = 10;
            }
            this.choice_use_time_left_list = [];
            for (let i = 0; i < array_length; i++) {
                var time = i + 1;
                this.choice_use_time_left_list.push(time + "시간");
            }

            this.step = 15;
            this.my_seat_product_name = item.goods_group_name;
            this.my_seat_product_time = item.goods_time;
            this.my_seat_product_end_datetime = item.use_end_datetime;
            this.my_seat_product_left_time = item.left_time + '시간';
            this.my_seat_product_purchase_history_id = item.seat_purchase_history_id;

            if (this.my_seat_product_end_datetime == null) {
                var str_goods_time = this.my_seat_product_time;
                var goods_time_parser = str_goods_time.split('일');
                // var str_date = this.$store.getters['get_str_datetime'];
                var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
                // 날짜(일) 더하기

                this.my_seat_product_end_datetime = this.$moment(str_date).add(Number(goods_time_parser[0]), 'd').format('YYYY-MM-DD HH:mm:00');
            }
        },
        step_controll(val) {
            this.before_step = this.step;
            this.step += val;

            if (this.mileage_use_yn != 1 && this.sale_use_yn != 1 && this.step == 4) {
                this.step = 5;
            }

            if (this.step == 2 && this.seat_goods_group_id.length == 0) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `상품을 선택해 주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }

            if (this.step == 2) {
                this.seat_goods_time_list = [];
                this.seat_goods_time_eventlist = [];
                // 상품에 맞는 시간호출
                var first_seat_time_list = [];
                var event_seat_time_list = [];
                const fir_type = config.REQ_M_SEAT_TIME_GET_LIST;
                const data = {
                    'seat_goods_group_id': this.seat_goods_group_id,
                    'use_yn': 1
                };
                const sec_type = config.REQ_M_SEAT_EVENT_TIME_GET_LIST;
                // 상품 설정 여부 조회
                const useyn_type = config.REQ_SEAT_GOODS_USE_YN_GET;

                // 여러건 호출
                Promise.all(
                    [
                        this.$store.dispatch(fir_type.action_name, {
                            type: fir_type,
                            data: data
                        }),
                        this.$store.dispatch(sec_type.action_name, {
                            type: sec_type,
                            data: data
                        }),
                        this.$store.dispatch(sec_type.action_name, {
                            type: useyn_type,
                            data: data
                        })
                    ]
                ).then(responseList => {
                    // 응답 - 요청 순서별 응답 array
                    // this.seat_goods_time_list = responseList[0].data;
                    // this.seat_goods_time_eventlist = responseList[1].data;
                    for (let goods of responseList[0].data) {
                        goods.event_goods = false;
                        this.seat_goods_time_list.push(goods);
                    }
                    if (this.$store.getters['getStoreId'] == 334) {
                        if (this.use_extention_flag) {
                            let array = {
                                card_amount: "1,000",
                                day_count: null,
                                end_day_count: null,
                                end_time: "00:00",
                                event_goods: false,
                                hours: "60",
                                max_use_time: null,
                                seat_goods_group_id: 142,
                                seat_goods_id: 622,
                                start_time: "00:00",
                                store_id: 334
                            };

                            this.seat_goods_time_list.push(array);
                        }
                    }
                    for (let goods of responseList[1].data) {
                        goods.event_goods = true;
                        this.seat_goods_time_eventlist.push(goods);
                    }
                    for (let i = 0; i < this.seat_goods_time_eventlist.length; i++) {
                        this.seat_goods_time_eventlist[i].continue_goods_yn = 0;
                        this.seat_goods_time_list.active_class = ''
                        this.seat_goods_time_list.push(this.seat_goods_time_eventlist[i]);
                    }
                    this.use_time_settings_yn = responseList[2].data[0].use_time_settings_yn;
                    this.end_term_yn = responseList[2].data[0].end_term_yn;
                    // self.seat_time_list = first_seat_time_list.concat(event_seat_time_list);
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }

            if (this.step == 3 && this.seat_goods_item_name.length == 0) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `시간 상품을 선택해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step = this.before_step;
                return;
            }
            // if (this.step == 3 && this.choice_use_time === 0 && this.use_time_settings_yn == 1) {
            //     const alert_param = {
            //         code: this.$store.getters['get_popup_code'].POPUP_ALERT,
            //         message: `금일 사용시간을 선택해주세요.`,
            //         router: '',
            //     };
            //     this.$store.commit('set_popup_type', alert_param);
            //     this.step = this.before_step;
            //     return;
            // }

            if (this.mileage_use_yn == 1 && this.step == 4) {
                if (this.mileage_chk) {
                    if (this.use_mileage < this.use_min_amount) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `마일리지가 최소 금액보다 부족합니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.step = this.before_step;
                        return;
                    }
                }
                if (this.use_mileage == this.card_amount.replace(/,/g, "")) {
                    this.step = 5;
                }
            }

            if (this.milage_all && this.step == 4) {
                var card = 0;
                card = this.card_amount.replace(/,/g, "");

                card = card - Number(this.my_save_mileage) * 1;

                // this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                this.use_mileage = Number(this.my_save_mileage) * 1;

            }

            if (this.step == 4 && this.use_mileage > 0) {
                var card;
                card = this.card_amount.replace(/,/g, "");
                let amount = card;
                if (amount < this.use_mileage) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `마일리지가 결제 금액보다 큽니다.`,
                        router: '',
                    };
                    // this.$store.commit('set_popup_type', alert_param);
                    this.step = this.before_step;
                    this.use_mileage = 0;
                    return;
                } else {
                    //북마크
                    card = card - this.use_mileage;
                    if (card == 0) {
                        this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        // this.step = 7;
                    }

                    // this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                }
            }
            // } else if (this.step == 4 && this.use_mileage == 0 && !this.mileage_chk) {
            //     this.last_price_card = this.card_amount;
            // } else if (this.step == 4 && this.use_mileage == 0 && this.mileage_chk) {
            //     this.last_price_card = this.card_amount;
            // }

            if (this.step == 5) {
                if (this.discount_coupon && !this.discount_flag) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `쿠폰코드를 입력해주세요. `,
                        router: '',
                    }
                    this.$store.commit('set_popup_type', alert_param);
                    this.step = this.before_step;
                    return;
                }
                /* var price_card = this.last_price_card.replace(/,/g,"");
                //할인된 금액
                var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                // 계산된 최종금액
                var new_price_card = price_card - discounted_price_card;
                //최종금액
                this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //할인된 최종금액
                this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); */
            }

            if (this.mileage_use_yn != 1 && this.step == 3) {
                this.step = 4;
            }

            if (this.sale_use_yn != 1 && this.step == 4) {
                this.step = 5;
            }

        },
        update_items_status() { //이전에 셋팅되어있던 item(좌석/사물함/그룹룸) 의 상태값을 체크후 상태 업데이트
            var status_chk = this.$store.getters['getItem_update_check'];
            if (status_chk.last_status == 'lock') {
                const condition_type = config.REQ_UPDATE_AVAILABLE_STATUS;
                const condition_data = {
                    'item_id': status_chk.item_id,
                    'item': status_chk.item
                };
                this.$store.dispatch(condition_type.action_name, {
                    type: condition_type,
                    data: condition_data
                }).then(response => {
                    if (response.result) {
                        // 상태 체크를 위한 데이터 셋팅
                        this.$store.commit('set_Item_update_check', {
                            item_id: '',
                            item: '',
                            last_status: ''
                        });
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },

        step_controll_back() {

            if (this.step - this.before_step <= 1) {
                this.step -= 1;
            } else {
                this.step = this.before_step;
            }

            if (this.step === 0) {
                this.$store.commit('set_use_extend_flag', {
                    'use_extend_flag': false
                })
            }
            if (this.step == 0) {
                var router = this.$router;
                var last_url = this.$store.getters['get_last_url'];
                if (last_url == undefined ||
                    last_url == null ||
                    last_url == '' ||
                    last_url == 'undefined' ||
                    last_url == 'null' ||
                    last_url.length == 0) {
                    router.push('/');
                } else {
                    router.push(last_url); // 이동 위치를 입력
                }
            }

            if (this.mileage_use_yn != 1 && this.sale_use_yn != 1 && this.step == 4) {
                this.step = 2;
            }

            if (this.sale_use_yn != 1 && this.step == 4) {
                this.step = 3;
            }

            if (this.mileage_use_yn != 1 && this.step == 3) {
                this.step = 2;
            }

            /* if(this.step == 5){
                this.discount_coupon = false;
                this.discount_flag = false;
                // this.discounted_price_card = 0;
                var price_card = this.card_amount.replace(/,/g,"");
                this.last_price_card = price_card - this.use_mileage;
                this.last_price_card = this.last_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.discount_coupon_code = '';
            }
            if(this.step == 4){
                if(!this.discount_flag){
                    // this.use_mileage = 0;
                    // this.mileage_chk = false;
                    // this.discount_coupon = false;
                    // this.discount_flag = false;
                    this.discount_coupon_code = '';
                    // this.discounted_price_card = 0;
                    // this.last_price_card = this.card_amount;
                }

            } */
            if (this.step == 3) {
                if (this.use_mileage > 0) {
                    this.mileage_chk = true;
                } else {
                    this.mileage_chk = false;
                }
            }
            if (this.step == 2) {
                this.card_amount = '';
                this.last_price_card = '';
                this.price_text = '';
                this.seat_goods_item_name = '';
                this.my_select_goods_name = ''; 
                this.sub_product_name = '';
                this.end_date = '';
                this.division = '';
                this.use_mileage = '';
                this.mileage_text = '';
                this.discounted_price_card = '';
                this.discount_text = '';
                this.discount_flag = false;
                this.mileage_chk = false;
                this.discount_coupon = false;
                this.discount_coupon_code = '';
                this.choice_use_time_list = [];
                for (var i = 0; i < this.seat_goods_time_list.length; i++) {
                    this.seat_goods_time_list[i].active_class = "";
                }
            }
            if (this.step == 1) {
                this.card_amount = '';
                this.my_select_goods_name = '';
                this.last_price_card = '';
                this.price_text = '';
                this.seat_goods_item_name = '';
                this.sub_product_name = '';
                this.end_date = '';
                this.division = '';
                for (var i = 0; i < this.seat_goods_time_list.length; i++) {
                    this.seat_goods_time_list[i].active_class = "";
                }

                this.seat_goods_group_id = '';
                this.seat_goods_group_name = '';
                this.seat_goods_type_code = '';
                // this.seat_type_name ='';

                for (var i = 0; i < this.seat_product.length; i++) {
                    this.seat_product[i].active_class = "";
                }
            }

        },
        set_seat_goods_group_id(val, index) {
            /*if (val.day_count_yn === 1) { //dg0602 기간권, 주야간권, 고정석 등 기간권 성격을 띈 상품들
              const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `해당상품은 키오스크에서만 사용 가능합니다.`,
                router: '',
              };
              this.$store.commit('set_popup_type', alert_param);
              return;
            }*/

          //TODO dg0602 해당 상품을 가지고 있는지 체크한 후 없으면 진행, 있으면 팝업

          const type = config.REQ_MYPAGE_SEAT_GOODS_GET_GROUPS;
          const data = {
            store_id: this.store_id,
            user_id: this.user_id
          };
          this.$store.dispatch(type.action_name, {
            type: type,
            data: data
          }).then(response => {
              if (response.result) {
                let isgetGroup = false;
                if (response.data.length != 0) {
                  let mySeatDataArray = response.data;

                  for(let i =0; i<mySeatDataArray.length; i++) {
                    if(val.seat_goods_group_id == mySeatDataArray[i].seat_goods_group_id){
                      isgetGroup = true;
                      break;
                    }
                  }
                }
                if(isgetGroup && !this.use_extention_flag){

                  const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `현재 가지고 있는 상품이 있습니다.<br/>먼저 내상품&쿠폰목록에서 상품을 선택하세요.<br/><br/>추가 구매는 키오스크 상단 상품구매에서<br/>구입이 가능합니다.`,
                    router: '',
                  };
                  this.$store.commit('set_popup_type', alert_param);
                  return;
                }
              }
              if (this.use_extention_flag) {

                  if (val.time_zone_yn === 1) {
                      const alert_param = {
                          code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                          message: `해당상품은 연장등록이 불가능한 상품입니다.`,
                          router: '',
                      };
                      this.$store.commit('set_popup_type', alert_param);
                      return;
                  }
              }

              this.use_time_settings_yn = val.use_time_settings_yn;
              this.seat_goods_group_id = val.seat_goods_group_id;
              this.seat_goods_group_name = val.goods_group_name;
              this.seat_goods_type_code = val.seat_type_code;
              for (var i = 0; i < this.seat_product.length; i++) {
                  this.seat_product[i].active_class = "";
              }
              this.seat_product[index].active_class = "pay-content-on";
              // this.step_controll(1);
          }).catch(function (error) {
            console.log('error=============>', error);
          });
        },
        set_seat_time_product(time_data, index) {
            if (time_data.mobile_use_yn === 0) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `해당상품은 모바일에서 <br>사용이 불가능한 상품입니다.<br><span style="color:red;">상품 별도구매</span>를<br> 이용해 구매 가능합니다`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }

            for (var i = 0; i < this.seat_goods_time_list.length; i++) {
                this.seat_goods_time_list[i].active_class = "";
            }
            this.seat_goods_time_list[index].active_class = "pay-content-on";

            //이벤트 id가 있으면 행사상품 없으면 일반상품
            var event_item_chk = time_data.seat_event_goods_id;
            if (event_item_chk == null) {
                this.division = '일반';
                this.seat_event_goods_id = null;
            } else {
                this.division = '행사';
            }
            // var str_date = this.$store.getters['get_str_datetime'];
            var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
            this.end_day_count = time_data.end_day_count;

            // 시간권인 경우
            if (time_data.hours !== null && time_data.day_count === null) {
                this.seat_goods_item_name = time_data.hours / 60;
                this.sub_product_name = '시간';

                if(time_data.goods_name !== null && time_data.goods_name !== '' && time_data.goods_name !== undefined){
                    this.my_select_goods_name = time_data.goods_name;  
                }else if(time_data.event_goods_name !== null && time_data.event_goods_name !== '' && time_data.event_goods_name !== undefined){
                    this.my_select_goods_name = time_data.event_goods_name;
                }else{
                    this.my_select_goods_name = this.seat_goods_item_name + this.sub_product_name
                }  

                var tDate;
                this.use_hours_plan;
                this.expiration_date;
                if (this.end_term_yn === 0) {
                    if (this.use_extention_flag == true) {
                        tDate = this.$moment(this.use_extention_use_end_datetime).add(parseInt(time_data.hours), 'm');
                    } else {
                        tDate = this.$moment(this.now_date).add(parseInt(time_data.hours), 'm');
                    }
                } else {
                    if (this.use_extention_flag == true) {
                        tDate = this.$moment(this.use_extention_use_end_datetime).add(time_data.end_day_count, 'd');
                    } else {
                        tDate = this.$moment(this.now_date).add(time_data.end_day_count, 'd');
                    }
                }

                // 날짜(일) 더하기
                this.end_date = tDate.format('YYYY/MM/DD HH시mm분 ');
                this.end_date_for_server = tDate.format('YYYY-MM-DD HH:mm:00');
                if (this.my_seat_list[0] !== undefined) {}
                // 기간권인 경우
            } else if (time_data.hours === null && time_data.day_count !== null && (time_data.start_time === '00:00' && time_data.end_time === '00:00')) {
                this.day_count = time_data.day_count;
                this.seat_goods_item_name = time_data.day_count;
                this.sub_product_name = '일';
                var tDate;

                if(time_data.goods_name !== null && time_data.goods_name !== '' && time_data.goods_name !== undefined){
                    this.my_select_goods_name = time_data.goods_name;  
                }else if(time_data.event_goods_name !== null && time_data.event_goods_name !== '' && time_data.event_goods_name !== undefined){
                    this.my_select_goods_name = time_data.event_goods_name;
                }else{
                    this.my_select_goods_name = this.seat_goods_item_name + this.sub_product_name
                }  

                if (this.use_extention_flag) {
                    tDate = this.$moment(this.use_extention_use_end_datetime).add(this.seat_goods_item_name, 'd');
                } else {
                    tDate = this.$moment(this.now_date).add(this.seat_goods_item_name, 'd');
                }
                // 날짜(일) 더하기

                this.end_date = tDate.format('YYYY/MM/DD HH시mm분 ');
                this.end_date_for_server = tDate.format('YYYY-MM-DD HH:mm:00');
                // 주/야간권인 경우
            } else if (time_data.hours === null && time_data.day_count === null && (time_data.end_day_count === null || time_data.end_day_count === 0)) {
                if (this.use_extention_flag) {
                    var tDate = new Date(this.use_extention_use_end_datetime);
                } else {
                    var tDate = new Date(this.now_date);
                }

                // 날짜(일) 더하기
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();

                let hour = tDate.getHours();
                let min = tDate.getMinutes();
                let time = hour + ':' + min;

                if (time < time_data.start_time) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `상품의 시작시간 이후에 선택 가능합니다.`,
                        router: '',
                        image_type: 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.step -= 1
                    return;
                } else {

                    let start_time_date;
                    let end_time_date;
                    if (time_data.end_time === '00:00') end_time_date = '24:00';
                    else end_time_date = time_data.end_time
                    if (time_data.start_time === '00:00') start_time_date = '24:00';
                    else start_time_date = time_data.start_time;
                    // var date = new Date();
                    // let myNum = date.setHours(parseInt(end_time_date.split(':')[0])) - date.setHours(parseInt(start_time_date.split(':')[0]));
                    // let use_hour = Math.floor((myNum/(1000*60*60))%24);
                    // let use_hour = parseInt(end_time_date.split(':')[0]) - parseInt(start_time_date.split(':')[0]);
                    this.seat_goods_item_name = start_time_date + '~' + end_time_date;
                    this.sub_product_name = '';

                    if(time_data.goods_name !== null && time_data.goods_name !== '' && time_data.goods_name !== undefined){
                        this.my_select_goods_name = time_data.goods_name;  
                    }else if(time_data.event_goods_name !== null && time_data.event_goods_name !== '' && time_data.event_goods_name !== undefined){
                        this.my_select_goods_name = time_data.event_goods_name;
                    }else{
                        this.my_select_goods_name = this.seat_goods_item_name + this.sub_product_name
                    }  

                    var currentTime = (parseInt(end_time_date.split(':')[0])) + "시 " + (parseInt(end_time_date.split(':')[1])) + "분 ";
                    let h = (parseInt(end_time_date.split(':')[0]));
                    let m = (parseInt(end_time_date.split(':')[1]));
                    if (h < 10) {
                        h = '0' + h;
                    }
                    if (m < 10) {
                        m = '0' + m;
                    }

                    var currentTime_server = h + ':' + m + ':' + '00';
                    this.end_date = tDate = yyyy + '/' + mm + '/' + dd + ' ' + currentTime;
                    this.end_date_for_server = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
                    // this.now_date = yyyy + '-' + mm + '-' + dd + ' ' + start_time_date + ':00';
                }

                // 주/야간 기간권인 경우
            } else if (time_data.time_zone_yn == 1) { // 2020 08 28 주/야간 기간권 조건 수정
                if (this.use_extention_flag) {
                    var tDate = new Date(this.use_extention_use_end_datetime);
                } else {
                    var tDate = new Date();
                }
                // 날짜(일) 더하기
                tDate.setDate(tDate.getDate() + time_data.day_count); // 2020 08 28 주/야간 day_count 기준으로 만료기간 수정
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();
                var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
                var h = tDate.getHours();
                var m = tDate.getMinutes();
                let time = h + ':' + m;

                if (time < time_data.start_time) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `상품의 시작시간 이후에 선택 가능합니다.`,
                        router: '',
                        image_type: 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.step -= 1
                    return;
                } else {
                    let start_time_date;
                    let end_time_date;
                    if (time_data.end_time === '00:00') end_time_date = '24:00';
                    else end_time_date = time_data.end_time
                    if (time_data.start_time === '00:00') start_time_date = '24:00';
                    else start_time_date = time_data.start_time;

                    // let use_hour = parseInt(end_time_date.split(':')[0]) - parseInt(start_time_date.split(':')[0]);
                    this.seat_goods_item_name = start_time_date + '~' + end_time_date;
                    this.sub_product_name = '';

                    if(time_data.goods_name !== null && time_data.goods_name !== '' && time_data.goods_name !== undefined){
                        this.my_select_goods_name = time_data.goods_name;  
                    }else if(time_data.event_goods_name !== null && time_data.event_goods_name !== '' && time_data.event_goods_name !== undefined){
                        this.my_select_goods_name = time_data.event_goods_name;
                    }else{
                        this.my_select_goods_name = this.seat_goods_item_name + this.sub_product_name
                    }  

                    var currentTime = (parseInt(time_data.end_time.split(':')[0])) + "시 " + (parseInt(time_data.end_time.split(':')[1])) + "분 ";
                    let h = (parseInt(time_data.end_time.split(':')[0]));
                    let m = (parseInt(time_data.end_time.split(':')[1]));
                    if (h < 10) {
                        h = '0' + h;
                    }
                    if (m < 10) {
                        m = '0' + m;
                    }

                    var currentTime_server = h + ':' + m + ':' + '00';
                    this.end_date = tDate = yyyy + '/' + mm + '/' + dd + ' ' + currentTime;
                    this.end_date_for_server = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
                    // this.now_date = yyyy + '-' + mm + '-' + dd + ' ' + start_time_date + ':00';;
                }
            }
            this.atalk_end_date = this.end_date_for_server;
            // 최대 사용 시간일 경우
            this.choice_use_time_list = [];
            if (this.use_time_settings_yn === 1) {
                this.max_use_time = time_data.max_use_time;
                for (let i = 0; i < this.max_use_time; i++) {
                    var time = i + 1;
                    this.choice_use_time_list.push(time + '시간');
                }
                if (this.choice_use_time_list[0] != null) {
                    this.choice_use_time = this.choice_use_time_list[0].replace(/[^0-9]/g, '') * 60;
                } 
            }

            this.card_amount = time_data.card_amount;
            this.last_price_card = this.card_amount;
            this.price_text = '원';
            this.seat_goods_id = time_data.seat_goods_id;
            this.mileage_save_yn = time_data.mileage_save_yn;
            if (time_data.seat_event_goods_id) {
                this.seat_event_goods_id = time_data.seat_event_goods_id;
                this.seat_goods_id = null;
            }
            // this.step_controll(1);
        },
        set_mileage(type) {
            if (type) {
                this.mileage_chk = true;
                this.use_mileage = 0;
                this.mileage_text = '원';
            } else {
                if (!this.discount_flag) {
                    this.last_price_card = this.card_amount;
                } else {
                    let calcul_payment = parseInt(this.last_price_card.replace(/,/g, "")) + this.use_mileage
                    this.last_price_card = calcul_payment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.use_mileage = '';
                this.mileage_text = '';
                this.mileage_chk = false;
            }
        },
        set_mileage_button(value) { 
            if(this.use_min_amount > this.my_save_mileage){
                let use_min_amount_text = this.use_min_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `${use_min_amount_text} 마일리지 이상부터 사용 가능합니다.`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage = 0;
                return false;
            }
                       
            if(typeof value === 'number'){
                this.use_mileage += parseInt(value);
            }else {
                this.use_mileage =  this.my_save_mileage;
            }

            if (this.use_mileage > this.my_save_mileage) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `사용하시려는 마일리지가 보유하고계신 마일리지보다 큽니다`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage -= value;
                return;
            }

            let amount = this.pay_type === 0 ? this.last_price_cash : this.last_price_card;

            var remain_pay = parseInt(parseInt(amount.replace(/,/g,""))/this.use_min_unit)*this.use_min_unit;
            if(value === 'all'){
                this.use_mileage = this.my_save_mileage;
                if(this.use_mileage == 0 || this.use_mileage == '0'){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 없습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                }

                if(remain_pay > this.use_mileage){
                    remain_pay = parseInt(this.use_mileage/this.use_min_unit)*this.use_min_unit;
                    this.use_mileage = remain_pay;
                }


                if(this.use_min_amount > this.use_mileage || remain_pay > this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 충분하지않습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.use_mileage = 0;
                }
            }else if(value === 'cancel'){
                this.use_mileage = 0;
                this.last_price_card = this.card_amount;
                return false;
            }

            if(amount.replace(/,/g,"") < this.use_mileage){
                this.use_mileage = remain_pay;
            }

            var card = 0; 
            card = this.card_amount.replace(/,/g,"");
            card = card - Number(this.use_mileage) * 1;
            this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        },
        milage_payment(mileage_data, mileage_id) {
            this.mileage_id = mileage_id;
            this.my_save_mileage = mileage_data;
        },
        set_discount_coupon(type) {
            if (type) {
                this.discount_coupon = true;
                this.discounted_price_card = '0';
                this.discount_text = '원';
            } else {
                this.discount_coupon = false;
                this.discount_flag = false;
                if (this.discounted_price_card != 0) {
                    this.last_price_card = (parseInt(this.last_price_card.replace(/,/g, "")) + parseInt(this.discounted_price_card.replace(/,/g, ""))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.discounted_price_card = '';
                this.discount_text = '';
                this.discount_coupon_code = '';
            }
        },
        coupon_check() {
            //할인쿠폰 적용 여부
            if (this.discount_coupon) {

                const type = config.REQ_COUPON_GET;
                const data = {
                    'sale_code': this.discount_coupon_code.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-")
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    var result;
                    result = response.result;
                    if (result && !this.discount_flag && response.data.message) {
                        this.sale_id = response.data.data[0].sale_id;
                        this.sale_rate = response.data.data[0].sale_rate;

                        var price_card = this.last_price_card.replace(/,/g, "");
                        //할인된 금액
                        var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                        //계산된 최종금액
                        var new_price_card = price_card - discounted_price_card;
                        //최종금액
                        this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //할인된 최종금액
                        this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        // ++this.step;
                        this.step_controll(1);
                        this.discount_flag = true;

                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 적용되었습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (!result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (result && this.discount_flag) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 이미 적용되어있습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },
        //좌석 배정
        set_seat_user() {

            if (this.choice_use_left_time == 0 && this.my_seat_product_name == '시간충전권' ||
                this.choice_use_left_time == 0 && this.my_seat_product_name == '기간권') {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `사용시간을 선택해주세요. `,
                    router: '',
                }
                this.$store.commit('set_popup_type', alert_param);
                return;
            }

            if (this.use_extention_flag) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_SEAT_PRODUCT_USE_ASK_AGAIN,
                }
                this.$store.commit('set_popup_type', alert_param);

                // 이용연장을 위한 데이터 셋
                this.$store.commit('set_extention_data', {
                    seat_purchase_history_id: this.my_seat_product_purchase_history_id,
                    hour: this.choice_use_left_time * 60,
                    end_date: this.my_seat_product_end_datetime,
                    goods_name: this.my_seat_product_name,
                    goods_time: this.my_seat_product_time
                });

                // 이용연장 req

            } else {

                //좌석배정
                const type = config.REQ_SEAT_USE_INSERT;
                const data = {
                    'data': {
                        'seat_id': this.seat_id,
                        'seat_purchase_history_id': this.my_seat_product_purchase_history_id,
                        'use_end_datetime': this.my_seat_product_end_datetime,
                        'use_hours_plan': this.choice_use_left_time * 60,
                    }
                };

                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    if (response.result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `${this.seat_name}번 좌석이 배정되었습니다. `,
                            router: '/',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        var router = this.$router;
                        router.push('/');

                        //만약 좌석연장 프로세스 라면,

                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }

        },
        async do_pay_check() {
            if(this.lock_time <= 0){              
              this.limit_time_popup();
              this.skip_flag = false;
              return;
            }
            this.return_flag = await this.lock_extention();

            if(!this.return_flag)
              return;
            let self = this;
            if (this.last_price_card == 0) {
                let result = {
                    "cno": null,
                    "pay_type": null
                };
                self.do_pay(result);
            } else {
                //결제모듈 
                var pay_info = {
                    mall_id: this.$store.getters['getStoreInfo'].store_imp_code, // 가맹점 ID
                    // mall_id : 'T5102001', // 가맹점 ID
                    mall_nm: this.$store.getters['getStoreInfo'].store_name, // 가맹점명
                    //product_nm: this.seat_goods_group_name + '_' + this.seat_goods_item_name + '' + this.sub_product_name, // 상품이름
                    product_nm: this.seat_goods_group_name + '_' + this.my_select_goods_name, 
                    product_amt: this.last_price_card != 0 ? this.last_price_card.replace(/,/g, "") : this.last_price_card, // 결제금액
                    product_expr: "", // 서비스기간 : YYYYMMDD, 예) 20201231
                    user_id: this.$store.getters['getUser'].user_hp, // 가맹점 고객 ID(가맹점 고객 번호) 
                    user_no: this.$store.getters['getUser'].user_id, // 가맹점 고객 일련번호
                    user_nm: this.$store.getters['getUser'].name, // 가맹점 고객명
                    user_phone: this.$store.getters['getUser'].user_hp, // 가맹점 고객 번호
                    sp_user_define1 : this.$store.getters['getStoreInfo'].store_id, // 가맹점 아이디
                    sp_user_define2 : this.$store.getters['getStoreInfo'].store_name // 가맹점 이름
                }
                var callbackTemplate = function (command, result) {

                    if (result.res_cd === '0000') {
                        self.do_pay(result);
                    } else {
                        const alert_param = {
                            code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: result.res_msg,
                            router: '',
                        }
                        self.$store.commit('set_popup_type', alert_param);
                        // this.$router.push('/')
                        // this.update_items_status()
                    }
                };
                mobileBriddgeConn(pay_info, callbackTemplate);
            }

        },
        //결제
        do_pay(result) {

            // this.now_date = this.$moment().format('YYYY-MM-DD HH:mm:00');
            var self = this;
            var left_time;

            //기간권인지 시간권인지 체크
            if (this.sub_product_name == '시간') {
                left_time = this.seat_goods_item_name * 60;
            } else {
                left_time = 0;
            }

            var payment_kind_code;
            var payment_amount;
            var goods_amount;
            var sale_amount;
            var card_div;
            //현금 / 카드 사용여부 체크 그에따른 값 셋팅
            payment_kind_code = 'CARD';
            payment_amount = this.last_price_card == 0 ? this.last_price_card : this.last_price_card.replace(/,/g, "");
            goods_amount = this.card_amount;
            sale_amount = this.discounted_price_card;
            card_div = this.card_installment // 0 = 일시불 2 = 2개월
            goods_amount = goods_amount.replace(/,/g, "");

            // 마일리지 사용여부 체크
            var mileage = {};
            if (this.mileage_chk) {
                mileage = {
                    'total_amount': Number(this.my_save_mileage) - this.use_mileage, // '나의 마일리지총액', => 나의 마일리지총액 - 마일리지 사용 금액
                    'change_amount': this.use_mileage // '변동_금액',  => 마일리지 사용 금액
                }
            }

            //할인쿠폰 사용여부 체크
            var sale = {};

            if (this.discount_coupon && this.discount_flag) {
                sale = {
                    'sale_id': this.sale_id
                }
                sale_amount = sale_amount.replace(/,/g, "");
            } else {
                this.sale_id = null;
                sale_amount = '';
            }
            //사용 종료시간 무제한 체크
            if (this.end_date == '무제한') {
                this.end_date_for_server = '0000-00-00 00:00:00';
            }
            //이용연장 구매라면

            var get_item_code = this.$store.getters['get_tab_code_list'];
            for (let i = 0; i < get_item_code.length; i++) {
                if (get_item_code[i].code_name == "좌석") {
                    get_item_code = get_item_code[i].code;
                    break;
                }
            }
            if (!this.cash_receipt_flag) {
                this.cash_receipt = '0';
            }

            const type = config.REQ_PAYMENT_INSERT;

            if (self.choice_use_time > 0) {

                var tDate = new Date(self.now_date);

                tDate.setMinutes(tDate.getMinutes() + self.choice_use_time);

                tDate.setDate(tDate.getDate());
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();
                var h = tDate.getHours();
                var m = tDate.getMinutes();

                if (h < 10) {
                    h = '0' + h;
                }
                if (m < 10) {
                    m = '0' + m;
                }
                var currentTime = h + ":" + m + ':00';

                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }
                self.expiration_date = self.end_date_for_server;
                self.end_date_for_server = tDate = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
            } else {
                var tDate = new Date(self.now_date);
                tDate.setMinutes(tDate.getMinutes() + left_time);

                tDate.setDate(tDate.getDate());
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();
                var h = tDate.getHours();
                var m = tDate.getMinutes();

                if (h < 10) {
                    h = '0' + h;
                }
                if (m < 10) {
                    m = '0' + m;
                }
                var currentTime = h + ":" + m + ':00';

                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }
                self.expiration_date = self.end_date_for_server;
                //this.end_date_for_server = tDate = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

            }
            if (self.special_goods_flag) {

                var len_chk = self.choice_use_time_list.length;
                var val_chk = (len_chk) * 60;
                if (val_chk == self.choice_use_time) {
                    self.choice_use_time = 0;
                }

            }
            var dir_exten;
            var set_use_status_code;
            if (self.use_extention_flag) {
                dir_exten = true;
                set_use_status_code = 'WAITING';
                // this.end_date_for_server = null;
                // this.now_date = null;
            } else {
                dir_exten = false;
                set_use_status_code = 'USING';
            }
            var startDate = self.$moment(self.now_date).format('YYYY-MM-DD HH:mm:00'); // 영수증용 시작시간 => seat use 테이블의 start_date_time과 동일하게
            const data = {
                'data': {
                    'mileage_yn': self.mileage_chk, //'마일리지_사용_여부', Y or N
                    'sale_yn': self.discount_coupon, // 할인쿠폰 사용여부
                    'purchase_type': get_item_code, //'구매_타입', // seat || locker || groom
                    'dirUseCheck': true, //false 상품구매 true 즉시사용
                    'mobile_yn': true, // 모바일 여부,
                    'dir_exten': dir_exten, //연장상품 즉시 구매 여부
                    'extention_flag': self.use_extention_flag, // 연장여부
                    'mileage_save_yn': self.mileage_save_yn, // 상품별 마일리지 적립 여부

                    'payment': {
                        'sale_id': self.sale_id, //'할인권_ID'
                        'payment_kind_code': payment_kind_code, // 현금인지 카드인지
                        'payment_status_code': 'COMPLETE',
                        'goods_type_code': get_item_code, // TAB 에 달려있는 데이터를 넣어줘야함
                        'approval_number': self.app_number,
                        'payment_amount': payment_amount * 1,
                        'goods_amount': goods_amount * 1,
                        'sale_amount': sale_amount * 1,
                        'card_div': card_div,
                        'payment_kind_name': self.payment_kind_name, // 카드사명
                        'card_number': self.card_number, // 카드번호
                        'goods_name': self.seat_goods_group_name + '_' + this.my_select_goods_name, 
                        'seat_name': this.seat_name,
                        'cash_receipt': self.cash_receipt, // 현금 영수증
                        'cno': result.cno,
                        'pay_type': result.pay_type
                    },
                    // 마일리지_사용_여부가 'Y'일때
                    mileage: mileage,
                    // 할인쿠폰_적용_여부가 'Y'일때
                    'sale': sale,
                    'purchase': {
                        // seat_purchase인 경우
                        'seat_id': self.seat_id,
                        'seat_goods_id': self.seat_goods_id, // '좌석_상품_ID',
                        'seat_event_goods_id': self.seat_event_goods_id,
                        'seat_coupon_user_id': null, // '좌석_쿠폰_사용자_ID',
                        'mileage_id': self.mileage_id, // '마일리지_ID',
                        'use_status_code': set_use_status_code, // '사용_상태_code', //
                        'use_end_datetime': self.end_date_for_server, // '사용_종료_시간'
                        'expiration_date': self.expiration_date, // '유효기간'
                        'use_start_datetime': self.now_date,
                        'use_hours_plan': (self.choice_use_time == 0) ? left_time : self.choice_use_time, //'사용_계획_시간',
                        'use_total_time': 0, // '사용_총_시간(데이터: 0)',
                        'left_time': left_time, // '남은_시간(사용_총_시간)',
                        'time_type': self.sub_product_name === '' ? null : self.sub_product_name,
                        'end_day_count': self.end_day_count,
                        'use_time_settings_yn': self.use_time_settings_yn, // 사용시간 설정 상품인지 판단,
                        'startDate_for_receipt': startDate,
                        'atalk_end_date': self.atalk_end_date

                    }
                }
            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            // return
            self.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                if (response.result) {
                    if(response.message){
                        self.step_controll(1);
                        self.$store.commit('set_Item_update_check', {
                            item_id: self.seat_id,
                            item: 'seat',
                            last_status: 'using'
                        });
                    }else{
                        const alert_param = {
                            code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `<span>다른 고객이 자리를 먼저 점유해 상품으로 전환되었습니다.</span><br><span>마이페이지에서 확인하세요.</span>`,
                            router: '',
                        }
                        self.$store.commit('set_popup_type', alert_param);
                        this.$router.push('/mypage');
                        return;
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        // 쿠폰입력
        coupoun_input(type_num) {
            if (type_num == 'del') {
                if (this.discount_coupon_code.length != 0) {
                    this.discount_coupon_code = this.discount_coupon_code.substr(0, this.discount_coupon_code.length - 1);
                }
            } else {
                if (this.discount_coupon_code.length <= 11) {
                    this.discount_coupon_code = this.discount_coupon_code + type_num;
                } else {
                    return false;
                }
            }
        },
        use_my_coupon_alarm() {
            this.$store.commit('set_seat_move_step', 0);

            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST,
            }
            this.$store.commit('set_popup_type', alert_param);

            // 이용연장을 위한 데이터 셋
            this.$store.commit('set_extention_data', {
                // seat_purchase_history_id: this.my_seat_product_purchase_history_id,
            });
        },
        get_left_menu() {
            this.left_menu_list = [];
            this.left_menu_list.push({
                active_class: "process_on",
                img_src: require("../../assets/image/process02_on.png"),
                menu_name: "상품선택",
                nomal_step: 2
            });
            this.left_menu_list.push({
                active_class: "",
                img_src: require("../../assets/image/process03_on.png"),
                menu_name: "시간선택",
                nomal_step: 3
            });
            if (this.mileage_use_yn != 0) {
                this.left_menu_list.push({
                    active_class: "",
                    img_src: require("../../assets/image/process04_on.png"),
                    menu_name: "마일리지",
                    nomal_step: 4
                });
            }
            if (this.sale_use_yn != 0) {
                this.left_menu_list.push({
                    active_class: "",
                    img_src: require("../../assets/image/process05_on.png"),
                    menu_name: "할인쿠폰",
                    nomal_step: 5
                });
            }
            this.left_menu_list.push({
                active_class: "",
                img_src: require("../../assets/image/process06_on.png"),
                menu_name: "결제",
                nomal_step: 6
            });
            this.left_menu_list.push({
                active_class: "",
                img_src: require("../../assets/image/process07_on.png"),
                menu_name: "완료",
                nomal_step: 7
            });

        },
        async lock_extention(){
          let flag = false;
          const condition_type = config.REQ_UPDATE_LOCK_EXTENTION_STATUS;
          const condition_data = {
              'item_id': this.seat_id,
              'item': 'seat'
          };
          await this.$store.dispatch(condition_type.action_name, {
              type: condition_type,
              data: condition_data
          }).then(response => {
              if (!response.result) {
                clearInterval(this.lock_timer);
                const alert_param = {
                  code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                  message: '유효성 인증에 실패하여 처음화면으로 돌아갑니다.',
                  router: '',
                }
                this.$store.commit('set_popup_type', alert_param);
                setTimeout(() => {this.$router.push('/')}, 3000);
                flag = false;
              }else{
                flag = true;
              }
          }).catch(function (error) {
              console.log('error=============>', error);
          });
          return flag;
        },        
        limit_time_popup(){
          clearInterval(this.lock_timer);
          const alert_param = {
              code: this.$store.getters['get_popup_code'].POPUP_ALERT,
              message: '유효시간이 경과되어 처음화면으로 돌아갑니다.',
              router: '',
          }
          this.$store.commit('set_popup_type', alert_param);
          setTimeout(() => {this.$router.push('/')}, 3000);
        },
        //250514 이용안내 팝업용으로 추가
        async get_usage_guide(){
            const type = config.REQ_GET_USAGE_GUIDE;
            const data = {
                store_id: this.$store.getters['getStoreInfo'].store_id,
            };
            try {
                const response = await this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                });
                //console.log(response)
                if(response.use_yn == 'y'){
                    return response;
                }
                return null;
            } catch (error) {
                console.log('error=============>', error);
                return null;  //실패시 대비
            }
        },
        async open_guide(){
            let send_data = null;
            const result = await this.get_usage_guide();
            //console.log(result)
            if (result) {
                send_data = { 
                            seat_guide: result.seat_guide, 
                            locker_guide: result.locker_guide, 
                            groom_guide: result.groom_guide
                        }
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_USE_GUIDE,
                    data: send_data
                }
                this.$store.commit('set_popup_type', alert_param);
            }
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.refund = this.$store.getters['get_refund_text'];
            // main 쪽 좌석 라커 그룹룸 보여주게할 값 셋팅
            this.$store.commit('change_main_tab_chk', {
                value: 0 // =>0좌석 1 사물함 2 그룹룸
            });

            // 매장별 마일리지 또는 할인쿠폰 사용여부 데이터
            var yndata = this.$store.getters['getUseyn'];
            if (typeof yndata == "undefined") {
                this.sale_use_yn = 0;
                this.mileage_use_yn = 0;
            } else {
                this.sale_use_yn = yndata.sale_apply_yn;
                this.mileage_use_yn = yndata.seat_use_yn;
                this.use_min_unit = yndata.use_min_unit;
                this.use_min_amount = yndata.use_min_amount;
            }
            // 왼쪽메뉴
            this.get_left_menu();

            var seat_data = this.$store.getters['get_select_seat'];

            this.seat_name = seat_data[0].seat_name;
            this.seat_id = seat_data[0].seat_id;
            this.seat_type_code = seat_data[0].seat_type_code;
            this.seat_type_name = seat_data[0].seat_type_name;
            this.seat_status_code = seat_data[0].seat_status_code;
            // 가져온 정보중 seat_type_code 사용하여 해당타입에 맞는 좌석상품 호출
            const type = config.REQ_SEAT_GOODS_GET_LIST;
            const data = {
                'seat_type_code': this.seat_type_code,
                'use_yn': 1
            };
            var user_data = this.$store.getters['getUser'];

            this.user_id = user_data.user_id;
            this.userName = user_data.name;
            this.user_Ph_number = user_data.user_hp;
            const my_info_data = {
                'user_id': this.user_id
            };

            // 내 좌석 상품목록
            const myproduct_list_type = config.REQ_MYPAGE_SEAT_GOODS_GET_LIST;
            // 내 쿠폰목록
            const mycoupon_list_type = config.REQ_MYPAGE_COUPON_GOODS_GET_LIST;

            Promise.all(
                [
                    this.$store.dispatch(myproduct_list_type.action_name, {
                        type: myproduct_list_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(mycoupon_list_type.action_name, {
                        type: mycoupon_list_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    })
                ]
            ).then(responseList => {
                // 응답 - 요청 순서별 응답 array
                this.my_seat_product_list = responseList[0].data;
                this.my_coupon_list = responseList[1].data;
                if (responseList[2].data.length != 0) {
                    for (var i = 0; i < responseList[2].data.length; i++) {
                        // if(responseList[2].data[i].goods_name != null && responseList[2].data[i].goods_name.length > 1){
                        //     responseList[2].data[i].goods_group_name = responseList[2].data[i].goods_name;
                        // }
                        responseList[2].data[i].active_class = "";
                        responseList[2].data[i].show_class = "y";
                        // if(responseList[2].data[i].continue_goods_yn  == 0){
                        //     responseList[2].data[i].show_class = "y";
                        // }else{
                        //     responseList[2].data[i].show_class = "n";
                        // }

                        if(responseList[2].data[i].time_zone_yn === 1){
                            //250612 주야간권 분단위까지 체크하도록 수정 
                            let start_times = responseList[2].data[i].start_time.split(':');
                            let end_times = responseList[2].data[i].end_time.split(':');

                            let start_min = Number(start_times[0]) * 60 + Number(start_times[1]);
                            let end_min = Number(end_times[0]) * 60 + Number(end_times[1]);

                            let now = this.$moment();
                            let now_min = now.hours() * 60 + now.minutes();
                            
                            // 자정처리(00:00을 24:00으로 간주)
                            if (end_min === 0) {
                                end_min = 24 * 60;
                            }
                            if(start_min < end_min){
                                // 하루가 넘어가지 않는 조건
                                if(start_min <= now_min && now_min < end_min ){
                                    responseList[2].data[i].show_class = "y"
                                }else{
                                    responseList[2].data[i].show_class = "n"
                                }
                            }else{
                                // 하루가 넘어가는 조건
                                if((start_min <= now_min && now_min < 1440) || (0 <= now_min && now_min < end_min)){
                                    responseList[2].data[i].show_class = "y"
                                }else{
                                    responseList[2].data[i].show_class = "n"
                                }
                            }
                            /*
                            var start_time = responseList[2].data[i].start_time.split(':')
                            var end_time = responseList[2].data[i].end_time.split(':')
                            let diff = Number(start_time[0]) - Number(end_time[0])

                            var today = new Date()
                            var today_h = today.getHours()
                            var today_mm = today.getMinutes()

                            if(today_h >= Number(start_time[0]) && today_h < Number(end_time[0])){
                                responseList[2].data[i].show_class = "y"
                            }else if(today_h >= Number(start_time[0]) && (today_h - diff) <= Number(end_time[0]) || Number(start_time[0]) > Number(end_time[0]) && Number(end_time[0] > today_h)){
                                responseList[2].data[i].show_class = "y"
                            }else{
                                responseList[2].data[i].show_class = "n"
                            }
                            */
                        }
                    }

                }
                this.seat_product = responseList[2].data;
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            //내좌석 상품정보를 호출
            const myProduct_and_seat_data = config.REQ_SEAT_USE_GET_LIST;
            const req_data = {};
            this.$store.dispatch(myProduct_and_seat_data.action_name, {
                type: myProduct_and_seat_data,
                data: req_data
            }).then(response => {
                if (response.data.length == 0 || response.data.length > 1) {
                    // 내가 사용중인 좌석이 하나도없고 새로운 좌석을 사용하려 하는중이라면 해당 좌석 상태 UPDATE
                    const condition_type = config.REQ_UPDATE_LOCK_STATUS;
                    const condition_data = {
                        'item_id': this.seat_id,
                        'item': 'seat'
                    };
                    this.$store.dispatch(condition_type.action_name, {
                        type: condition_type,
                        data: condition_data
                    }).then(response => {
                        if (response.result) {
                            // 상태 체크를 위한 데이터 셋팅
                            this.$store.commit('set_Item_update_check', {
                                item_id: this.seat_id,
                                item: 'seat',
                                last_status: 'lock'
                            });
                        }
                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                    //update

                }
                // 데이터를 담아낸뒤
                for (let i = 0; i < response.data.length; i++) {
                    if (this.seat_id == response.data[i].seat_id) {
                        this.use_extention_seat_purchase_history_id = response.data[i].seat_purchase_history_id;
                        this.use_extention_use_end_datetime = response.data[i].goods_end_datetime;
                        this.use_extention_use_start_datetime = response.data[i].use_start_datetime;
                        this.use_extention_flag = true;
                        this.use_hours_plan = response.data[i].use_hours_plan;
                    }
                }
                this.$store.commit('setExtention_flag', {
                    value: this.use_extention_flag
                });

            }).catch(function (error) {
                console.log('error=============>', error);
            });
            this.now_date = this.$moment().format('YYYY-MM-DD HH:mm:00');

            const type1 = config.REQ_ANOTHER_SEAT_USE_ENDTIME;
            const data1 = {
                seat_id: this.seat_id
            };
            this.$store.dispatch(type1.action_name, {
                type: type1,
                data: data1
            }).then(response => {
                if (response.result) {
                    if (response.data.length != 0) {
                        this.my_seat_list = response.data;
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            
            // 250514 이용안내 추가 
            this.get_usage_guide()
            .then(result => {
                if (result && result.use_yn === 'y') {
                    this.usage_guide_useyn = 'y';
                    this.usage_guide_data = result;
                }
            })
            .catch(error => {
                console.log('error=============>', error);
            });


        });
        
        this.lock_timer = setInterval(() => {
          this.lock_time--;
          if(this.lock_time <= 0 && this.step < 5){
            this.limit_time_popup();
          }
          this.$root.$el.onclick = () => {
            if(this.lock_time < this.lock_use_time){
              this.lock_extention();
            }
            this.lock_time = 480;
          }
        }, 1000)

    },
    computed: {
        get_popup_code() {
            return this.$store.getters.get_popup_type.code;
        },
        get_seat_move_step() {
            return this.$store.getters.get_seat_move_step;
        }
    },
    beforeDestroy() {
      this.update_items_status();
      this.$store.commit('set_payment_Start', false);
      this.$store.commit('set_reset_popup_type');
      this.lock_time = 480;
      clearInterval(this.lock_timer);

    },
    watch: {
        step() {
            for (var i = 0; i < this.left_menu_list.length; i++) {
                this.left_menu_list[i].active_class = '';
                if (this.left_menu_list[i].nomal_step == (this.step + 1)) {
                    this.left_menu_list[i].img_src = require("../../assets/image/process0" + (this.left_menu_list[i].nomal_step) + "_on.png");
                    this.left_menu_list[i].active_class = 'process_on';

                    for (var n = 0; n < i; n++) {
                        this.left_menu_list[n].active_class = 'process_finish';
                    }
                } else {
                    this.left_menu_list[i].img_src = require("../../assets/image/left_ico_0" + (this.left_menu_list[i].nomal_step) + ".png");
                }
            }
        },
        get_popup_code(val, OldVal) {},
        choice_use_time() {},
        get_seat_move_step() {
            this.step = this.$store.getters.get_seat_move_step;
            if (this.step == 0) {
                this.step = 1;
            }
        }

    },

}
</script>

<style>
.vdp-datepicker .vdp-datepicker__calendar {
    position: relative;
    width: 355%;
    height: 100%;

}

.good-body .info_area_2 {
    position: absolute;
    background: #fff;
    top: 10%;
    left: 40%;
    width: 632px;
    height: 650px;
    border: 3px solid #b9b9b9;
    border-radius: 2.5px;
    padding: 80px 60px 55px;
    font-size: 35px;
}

.btn-display-none {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Payment_seat.vue